import Vue from "vue"

export default new Vue({
  name: "PreIngestService",
  data: {},
  methods: {}
})



// WEBPACK FOOTER //
// ./src/PreIngest/PreIngestService.js